<template>
  <div class="site-header">
    <div class="site-header__box site-wrapper">
      <div class="site-header__brand" style="width: 200px;">
        <a :href="$store.state.pageInfo && $store.state.pageInfo.logoJumpUrl" class="logo"><img :src="$store.state.pageInfo && getUrl($store.state.pageInfo.systemLogo)"/></a>
      </div>
      <div class="site-header__nav" style="text-align:left;">
        <ul class="clearfix" style="margin-left: 16px;">
          <li v-show="nav.show" @click="routerHandle($route)" :class="{ active: menuActiveName === nav.router }" v-for="nav in navs"
            :key="nav.id">
            <router-link :to="{ name: nav.router }"> {{ nav.name }}</router-link>
          </li>
        </ul>
      </div>
      <div class="site-header__menu">
        <ul style="text-align: right;">
          <li v-if="$cookie.get('X-Admin-Token')" @click="$router.push({ name: 'cart' })">
            <el-badge :value="cartTotal !== 0 ? cartTotal : ''">
              <img @click="bellClick" src="@/assets/img/cart.png" height="32" width="32" />
            </el-badge>
          </li>
          <el-popover placement="bottom" width="400" trigger="click" popper-class="msgPop">
            <div style="height: 100%;position: relative;" v-loading="loading">
              <div v-if="noMsgData" style="text-align: center;padding-top: 80px;">
                <img src="@/assets/img/noData.png">
                <p>暂无未读消息</p>
              </div>
              <dl v-for="v in msgList.slice(0, 4)" :key="v.id">
                <dt>
                  <img width="32px" height="32px" :src="getIcon(v.msgType)" />
                </dt>
                <dd @click="seeDetail(v.id)">
                  <h3 class="clearFLoat">系统消息&emsp;<span style="float: right;">{{ v.createTime }}</span></h3>
                  <p style="width: 230px;" class="ellipsis">{{ v.msgTitle }}</p>
                </dd>
              </dl>
              <el-button style="width:100%;text-align: center;color:#333;padding:16px 0;position: absolute;bottom: 0;"
                type="text" @click="$router.push({ name: 'message' })">查看全部</el-button>
            </div>
            <li slot="reference" v-if="$cookie.get('X-Admin-Token')">
              <el-badge :value="msgTotal !== 0 ? msgTotal : ''">
                <img @click="bellClick" src="@/assets/img/bell.png" height="22" width="22" />
              </el-badge>
            </li>
          </el-popover>
          <li style="margin-right:0;">
            <el-dropdown :show-timeout="0" placement="bottom">
              <span class="el-dropdown-link" v-if="$cookie.get('X-Admin-Token')">
                <el-image :src="getUrl($cookie.get('avatar'))">
                  <div slot="error" class="image-slot">
                    <img width="36" height="36" :src="require('@/assets/img/avatar.png')"/>
                  </div>
                </el-image>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="openMyInfo" v-if="$cookie.get('isOtherUser')!='true'">个人信息</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push({ name: 'resetpwd' })">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push({ name: 'billingInforManage' })">开票信息管理</el-dropdown-item>
                <el-dropdown-item v-if="$cookie.get('isAdmin') == 'true'" @click.native="$router.push({ name: 'accountMg' })">账号管理</el-dropdown-item>
                <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <p v-if="!$cookie.get('X-Admin-Token')" style="font-size: 14px;font-weight: bold;color: #4D4D4D;"><span @click="$router.push({ name: 'login' })">登录</span><el-divider direction="vertical"></el-divider><span @click="$router.push({ name: 'register' })">注册</span></p>
          </li>
        </ul>
      </div>
    </div>
    <msgDetaile v-if="msgVisible" ref="msgDetaile"></msgDetaile>
  </div>
</template>

<script>
import msgDetaile from "@/views/message/msgDetaile.vue";
import { clearLoginInfo, dateFtt,RSAEncrypt,previewUrl } from "@/utils";
export default {
  components: {
    msgDetaile
  },
  data() {
    const hasToken = this.$cookie.get("X-Admin-Token");
    const isOtherUser = this.$cookie.get('isOtherUser')=='true';
    return {
      loading: false,
      msgVisible: false,
      noMsgData: false,
      msgList: [],
      navs: [
        {
          id: 1,
          name: "检测服务",
          router: "home",
          show: true
        },
        {
          id: 2,
          name: "订单管理",
          router: "order",
          show: hasToken
        },
        {
          id: 3,
          name: "企业信息",
          router: "enterprise",
          show: hasToken && !isOtherUser
        },
        {
          id: 5,
          name: "我的报告",
          router: "myReport",
          show: true
        },
        {
          id: 4,
          name: "报告查询",
          router: "report",
          show: true
        }
      ],
      count:'',
      count1:'',
      showCaptcha:true,
      showCaptcha1:true,
      timer:null,
      timer1:null,
    };
  },
  computed: {
    menuActiveName: {
      get() {
        // 【取值】
        return this.$store.state.menuActiveName;
      },
      set(val) {
        // 【存储】同步操作
        // 异步操作 this.$store.dispatch() getters.方法名【取值】
        this.$store.commit("updateMenuActiveName", val);
      },
    },
    cartTotal: {
      get() {
        return this.$store.state.cartTotal;
      },
      set(num) {
        this.$store.commit("updateCartTotal", num);
      },
    },
    msgTotal: {
      get() {
        return this.$store.state.msgTotal;
      },
      set(num) {
        this.$store.commit("updateMsgTotal", num);
      }
    }
  },
  created() {
    this.$cookie.get('X-Admin-Token') && this.getCount();
    this.routerHandle(this.$route);
  },
  watch: {
    $route: "routerHandle",
  },
  methods: {
    getUrl(url){
      return previewUrl(url);
    },
    getIcon(type){
      if(type=='XTXX'){
        return require('@/assets/img/sysRing.png')
      }
      return require('@/assets/img/sysRing1.png')
    },
    bellClick() {
      this.loading = true;
      let params = {
        current: 1,
        size: 10,
        data: {
          creatorName: "",
          msgTitle: "",
          readSt: 0,
          msgType:''
        }
      }
      this.$http.post(this.$api.msgApi.getMsg, params).then(({ data }) => {
        this.loading = false;
        data.data.list = data.data.list || [];
        data.data.list.forEach(v => {
            v.createTime = dateFtt(new Date(v.createTime));
        })
        this.msgList = data.data.list || [];
        this.noMsgData = !this.msgList.length;
      });
    },
    seeDetail(id) {
      this.$http.get(this.$api.msgApi.selectMessageDetail, { params: { id: id } }).then(({ data }) => {
        this.msgVisible = true;
        this.getCount();
        this.$nextTick(() => {
          this.$refs.msgDetaile.init(data.data);
        });
      });
    },
    getCount() {
      this.$http.get(this.$api.pageInfoApi.getHeaderNumber).then(({ data }) => {
        this.cartTotal = data.data.cartNum;
        this.msgTotal = data.data.msgNum;
      });
    },
    routerHandle(nav) {
      this.menuActiveName = nav.name || nav.router;
    },
    // 退出登录
    logoutHandle() {
      this.$http.post(this.$api.shiroApi.logout,null).then(() => {
        const userT = this.$cookie.get("userType");
          if(userT && userT == 'fbcUser'){
            this.fbcLogout();
          }
					clearLoginInfo();
          location.href = window.SITE_CONFIG["baseUrl"]+"/#/login";
				}).catch(()=>{});
    },
    fbcLogout(){
      this.$http.get(window.SITE_CONFIG["fbcUrl"], null).then(() => {});
    },
    openMyInfo(){
      this.$router.push({ name: "register", query: { userInfo: 1} });
    },
    getCaptchaHandle(timer,count,showCaptcha,phone){
      if(!this[showCaptcha])return
      this.$refs["dataForm"].validateField(phone, (valid) => {
        if (!valid) {
          let params = {
            phone: this.detail[phone],
          };
          this.$http.post(this.$api.shiroApi.sendCaptchaByPhone, params).then(({ data }) => {
            if (data.code === 200) {
              this.countdown(timer,count,showCaptcha);
            }
          });
        }
      });
    },
    countdown(timer,count,showCaptcha) {
      const TIME_COUNT = 60;
      if (!this[timer]) {
        this[count] = TIME_COUNT;
        this[showCaptcha] = false;
        this[timer] = setInterval(() => {
          if (this[count] > 0 && this[count] <= TIME_COUNT) {
            this[count]--;
          } else {
            this[showCaptcha] = true;
            clearInterval(this[timer]);
            this[timer] = null;
          }
        }, 1000);
      }
    },
    formOK(){
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.detail));
          params.password = RSAEncrypt(params.password),
          delete params.comfirmPassword;
          this.$http.post(this.$api.shiroApi.updateUser, params).then(({ data }) => {
            this.$message({
              message: data.msg,
              type: "success"
            });
            this.visible = false;
          });
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
/**header 高 */
$--header-height: 72px;

.site-header {
  height: $--header-height;
  line-height: $--header-height;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.04);
  position: relative;
  z-index: 99;

  &__box {
    display: flex;
  }

  &__brand {
    .logo {
      img {
        height: 48px !important;
        image-rendering: -webkit-optimize-contrast;
      }
    }
  }

  &__nav {
    flex: 1;
    text-align: center;

    ul>li {
      display: inline-block;

      &.active a {
        background: #1460ae;
        color: #fff;
      }

      a {
        display: block;
        font-size: 16px;
        padding: 0 24px;
        text-decoration: none;
      }
    }
  }

  &__menu {
    width: 400px;

    ul>li {
      display: inline-block;
      margin-right: 30px;
      cursor: pointer;

      i {
        font-size: 20px;
      }
    }

    .el-badge {
      display: inline;
      line-height: 80px;
    }

    .el-dropdown-link {
      display:flex; 
      .el-image{
        overflow:unset;
        ::v-deep .el-image__inner {
          vertical-align:middle;
          border-radius:50%;
          width:36px;
          height:36px;
        }
      }
    }
  }
}

.site-header__menu ul>span {
  display: inline-block;
  margin-right: 30px;
  cursor: pointer;
}

dl {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #F0F0F0;
  padding-bottom: 8px;

  dt {
    margin-right: 8px;
    margin-top: -16px;
  }

  dd {
    cursor: pointer;

    h3 {
      font-size: 14px;
      font-weight: bold;
      color: #333;

      span {
        font-size: 12px;
        font-weight: 400;
        color: #B3B3B3;
      }
    }

    p {
      padding-top: 4px;
      color: #666;
      line-height: 22px;
    }
  }
}
.getcaptcha {
  height: 42px;
  line-height: 42px;
  color: #1460AE;
  border: 1px solid #dcdfe6;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}
</style>
